import React, { Component } from 'react'
import { useActions } from '../../Action'
import { store } from '../../Store'
import { useContext, useEffect, useState } from 'react'

const ReportDetails = (props) => {
  const { state, dispatch } = useContext(store)
  const actions = useActions(state, dispatch)

  const { reportingData, osotReportData, Login, roles } = state
  const data = osotReportData && osotReportData.GetOSOTReportDetails
  const { StoreAgentRole } = Login
  // tradeid click role access
  const ReportingClickRoles = roles && roles.filter((r) => r.menu === 'Reporting' && r.section === 'ReportClickDetails') && roles && roles.filter((r) => r.menu === 'Reporting' && r.section === 'ReportClickDetails')[0]
  const agentclickRole = StoreAgentRole && StoreAgentRole.toUpperCase()
  return (
    <div>
      {data &&
        data.map(
          (item) =>
            item.isSelected && (
              <table className="mt-25 border border-solid  text-sm border border-black-2 bg-white">
                <tbody>
                  <tr className= "bg-white">
                    {ReportingClickRoles['TradeId'][agentclickRole] === 'SHOW' ?
                    (
                    <td className="w-370 h-50 pl-13 border">
                      <span className="font-bold">Trade-In ID </span> : {item.TradeId}
                    </td>
                    ) : (<td className="w-370 h-50 pl-13 border"/>)}
                    {ReportingClickRoles['JobType'][agentclickRole] === 'SHOW' ? (
                    <td className="w-370 h-50 pl-13 border">
                      <span className="font-bold"> Job Type </span>:&nbsp; {item.JobType}
                    </td>) : <td className="w-370 h-50 pl-13 border"/>}
                    {ReportingClickRoles['TenureCredit'][agentclickRole] === 'SHOW' ? (
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Customer Tenure Credit </span>:&nbsp; {item.CustomerTenureCredit}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    {ReportingClickRoles['DateReceivedAtWarehouse'][agentclickRole] === 'SHOW' ? (
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Date Received At Warehouse </span>:&nbsp; {item.DateReceivedAtWarehouse}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Service Order ID </span>:&nbsp; {item.ServiceOrderID}
                    </td>
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Parent Account Name </span>:&nbsp;{item.ParentAccountName}
                    </td>
                  </tr>
                  <tr className= "bg-white">
                    {ReportingClickRoles['StoreCode'][agentclickRole] === 'SHOW' ? (
                    <td className="w-370 h-50 pl-13 border">
                      <span className="font-bold"> Create by Code </span>:&nbsp; {item.StoreCode}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    {ReportingClickRoles['IMEIIn'][agentclickRole] === 'SHOW' ? (
                    <td className="w-370 h-50 pl-13 border">
                      <span className="font-bold"> IMEI IN </span>:&nbsp; {item.IMEIIn}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Total Credit </span>:&nbsp; {item.TotalCredit}
                    </td>
                    {ReportingClickRoles['DateAssessed'][agentclickRole] === 'SHOW' ? (
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Date Assessed </span>:&nbsp; {item.DateAssessed}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    {ReportingClickRoles['PaymentToVHA'][agentclickRole] === 'SHOW' ? (
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Payment to VHA </span>:&nbsp; {item.PaymentToVHA}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    <td className="h-50 w-370 pl-13 border">
                    <span className="font-bold"> App Condition </span>:&nbsp; {item.AppCondition}
                    </td>
                  </tr>
                  <tr className= "bg-white">
                    {ReportingClickRoles['StoreName'][agentclickRole] === 'SHOW' ? (
                    <td className="w-370 h-50 pl-13 border">
                      <span className="font-bold"> Created by Name </span>:&nbsp; {item.StoreName}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    {ReportingClickRoles['IMEIInManufacturer'][agentclickRole] === 'SHOW' ? (
                    <td className="w-370 h-50 pl-13 border">
                      <span className="font-bold"> IMEI IN Manufacture </span>:&nbsp; {item.IMEIInManufracturer}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Credit Application Period </span>:&nbsp; {item.CreditApplicationPeriod}
                    </td>
                    {ReportingClickRoles['AssessmentOutcome'][agentclickRole] === 'SHOW' ? (
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Assessment Outcome </span>:&nbsp; {item.AssessmentOutcome}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    {ReportingClickRoles['PaymentToVHADate'][agentclickRole] === 'SHOW' ? (
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Payment to VHA Date </span>:&nbsp; {item.PaymentToVHADate}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    <td className="h-50 w-370 pl-13 border">
                    <span className="font-bold"> Graded Condition </span>:&nbsp; {item.GradedCondition}
                    </td>
                  </tr>
                  <tr className= "bg-white">
                    {ReportingClickRoles['TeamMemberName'][agentclickRole] === 'SHOW' ? (
                    <td className="w-370 h-50 pl-13 border">
                     <span className="font-bold">Team Member Name </span>  : {item.TeamMemberName}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    {ReportingClickRoles['IMEIInModel'][agentclickRole] === 'SHOW' ? (
                    <td className="w-370 h-50 pl-13 border">
                      <span className="font-bold"> IMEI in Model/Variant </span>:&nbsp; {item.IMEIInModel}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    {ReportingClickRoles['BatchNbr'][agentclickRole] === 'SHOW' ? (
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Batch Number </span>:&nbsp; {item.BatchNumber}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    {ReportingClickRoles['FaultCode'][agentclickRole] === 'SHOW' ? (
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Fault Code </span>:&nbsp; {item.FaultCode}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Payment Variance </span>:&nbsp; {item.PaymentVariance}
                    </td>
                    <td className="h-50 w-370 pl-13 border">
                    <span className="font-bold"> Graded Price </span>:&nbsp; {item.GradedPrice}
                    </td>
                  </tr>
                  <tr className= "bg-white">
                    {ReportingClickRoles['TeamMemberId'][agentclickRole] === 'SHOW' ? (
                    <td className="w-370 h-50 pl-13 border">
                     <span className="font-bold"> Team Member ID </span> : {item.TeamMemberID}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    {ReportingClickRoles['IMEIOut'][agentclickRole] === 'SHOW' ? (
                    <td className="w-370 h-50 pl-13 border">
                      <span className="font-bold"> IMEI Out </span>:&nbsp; {item.IMEIOut}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    {ReportingClickRoles['ConsignmentDetails'][agentclickRole] === 'SHOW' ? (
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Consignment Details </span>:&nbsp; {item.ConsignmentDetails}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    {ReportingClickRoles['FaultReason'][agentclickRole] === 'SHOW' ? (
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Fault Reason </span>:&nbsp; {item.FaultReason}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Sub Channel Name </span>:&nbsp; {item.SubChannelName}
                    </td>
                    <td className="h-50 w-370 pl-13 border">
                    <span className="font-bold"> Raised Location </span>:&nbsp; {item.RaisedLocation}
                    </td>
                  </tr>
                  <tr className= "bg-white">
                  {ReportingClickRoles['CurrentJobStatus'][agentclickRole] === 'SHOW' ? (
                  <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Current Job Status </span>:&nbsp; {item.CurrentJobStatus}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    {ReportingClickRoles['IMEIOutManufacturer'][agentclickRole] === 'SHOW' ? (
                    <td className="w-370 h-50 pl-13 border">
                      <span className="font-bold">IMEI Out Manufacture </span> : {item.IMEIOutManufracturer}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    {ReportingClickRoles['ValidationRequired'][agentclickRole] === 'SHOW' ? (
                    <td className="w-370 h-50 pl-13 border">
                      <span className="font-bold"> Validation Required Y/N </span>:&nbsp; {item.ValidationRequired}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    {ReportingClickRoles['DaysPendingInStore'][agentclickRole] === 'SHOW' ? (
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Days Pending in Store </span>:&nbsp; {item.DaysPendingInStore}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Parent Code </span>:&nbsp; {item.ParentCode}
                    </td>
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> {}</span>
                    </td>
                  </tr>
                  <tr className= "bg-white">
                    {ReportingClickRoles['CurrentLocation'][agentclickRole] === 'SHOW' ? (
                    <td className="w-370 h-50 pl-13 border">
                     <span className="font-bold"> Current Location </span>  : {item.CurrentLocation}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    {ReportingClickRoles['IMEIOutModel'][agentclickRole] === 'SHOW' ? (
                    <td className="w-370 h-50 pl-13 border">
                      <span className="font-bold"> IMEI Out Model/Variant </span>:&nbsp; {item.IMEIOutModel}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    {ReportingClickRoles['DateCreated'][agentclickRole] === 'SHOW' ? (
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Date Created </span>:&nbsp; {item.DateCreated}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    {ReportingClickRoles['DaysPendingInTransit'][agentclickRole] === 'SHOW' ? (
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Days Pending in Transit </span>:&nbsp; {item.DaysPendingInTransit}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Region </span>:&nbsp; {item.Region}
                    </td>
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> {}</span>
                    </td>
                  </tr>
                  <tr className= "bg-white">
                    {ReportingClickRoles['CustomerPhoneMobile'][agentclickRole] === 'SHOW' ? (
                    <td className="w-370 h-50 pl-13 border">
                      <span className="font-bold"> Customer Phone Mobile </span> : {item.CustomerPhoneMobile}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    {ReportingClickRoles['QuotePrice'][agentclickRole] === 'SHOW' ? (
                    <td className="w-370 h-50 pl-13 border">
                      <span className="font-bold"> Quote Price </span>:&nbsp; {item.QuotePrice}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    {ReportingClickRoles['DateBatched'][agentclickRole] === 'SHOW' ? (
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Date Batched </span>:&nbsp; {item.DateBatched}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    {ReportingClickRoles['DaysPendingAssessment'][agentclickRole] === 'SHOW' ? (
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Days Pending Assessment </span>:&nbsp; {item.DaysPendingInAssessment}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Trading Name </span>:&nbsp; {item.TradingName}
                    </td>
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> {}</span>
                    </td>
                  </tr>

                  <tr className= "bg-white">
                    {ReportingClickRoles['CustomerBAN'][agentclickRole] === 'SHOW' ? (
                    <td className="w-370 h-50 pl-13 border">
                     <span className="font-bold"> Customer BAN </span> : {item.CustomerBAN}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    {ReportingClickRoles['BonusCredit'][agentclickRole] === 'SHOW' ? (
                    <td className="w-370 h-50 pl-13 border">
                      <span className="font-bold"> Bonus Credit </span>:&nbsp; {item.BonusCredit}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    {ReportingClickRoles['DatePickUp'][agentclickRole] === 'SHOW' ? (
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Date Pick Up or Lodge </span>:&nbsp; {item.DatePickupLodged}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    {ReportingClickRoles['OverAllAging'][agentclickRole] === 'SHOW' ? (
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Overall Aging </span>:&nbsp; {item.OverallAging}
                    </td>) : <td className="h-50 w-370 pl-13 border"/>}
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> Reporting State </span>:&nbsp; {item.ReportingState}
                    </td>
                    <td className="h-50 w-370 pl-13 border">
                      <span className="font-bold"> {}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            )
        )}
    </div>
  )
}

export default ReportDetails
